export const reviews = [
  {
    text: 'Людмила организовала поездку в Дубай — всё идеально: перелёт, отель, трансфер. Всегда была на связи и быстро решала любые вопросы.',
    name: 'Алина К.',
    origin: 'Ташкент',
    city: 'Ташкент',
    tour: 'ОАЭ, Дубай',
    manager: 'Людмила',
    rating: 5,
  },
  {
    text: 'Марина подобрала отличный тур в Турцию — отель у моря, без скрытых доплат. Обязательно вернёмся через неё!',
    name: 'Дмитрий М.',
    origin: 'Самарканд',
    city: 'Самарканд',
    tour: 'Турция, Анталия',
    manager: 'Марина',
    rating: 5,
  },
  {
    text: 'Алия помогла спланировать медовый месяц на Мальдивах — учла все пожелания. Поездка превзошла ожидания.',
    name: 'Нодира и Санжар',
    origin: 'Ташкент',
    city: 'Ташкент',
    tour: 'Мальдивы',
    manager: 'Алия',
    rating: 5,
  },
  {
    text: 'Первый раз летали заграницу с детьми. Ирина помогла с документами и подобрала семейный отель. Спасибо за терпение!',
    name: 'Елена С.',
    origin: 'Бухара',
    city: 'Бухара',
    tour: 'Египет, Sharm El Sheikh',
    manager: 'Ирина',
    rating: 5,
  },
  {
    text: 'Комила составила индивидуальный маршрут по Европе — музеи, рестораны, трансферы продуманы до мелочей.',
    name: 'Рустам А.',
    origin: 'Наманган',
    city: 'Наманган',
    tour: 'Италия, Франция',
    manager: 'Комила',
    rating: 5,
  },
  {
    text: 'Горящий тур в Таиланд Марина нашла за один день. Цена приятно удивила, отдых прошёл на отлично.',
    name: 'Камила Т.',
    origin: 'Фергана',
    city: 'Фергана',
    tour: 'Таиланд, Пхукет',
    manager: 'Марина',
    rating: 5,
  },
];
